export default __webpack_public_path__ + "static/media/avatar.934339d9.png";